import { graphql, useStaticQuery } from "gatsby"

export const useSiteMetadata = () => {
    const data = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    keywords
                    favicon
                    siteUrl
                }
            }
            wp {
                siteSettings {
                    seoGlobalSettings {
                        robotsMeta
                        openGraphImage {
                            sourceUrl
                        }
                    }
                }
            }
        }
    `)

    return {...data.site.siteMetadata,...data.wp.siteSettings}
}
